export default {
  title: {
    create: 'สร้างสินค้าใหม่',
    detail: 'รายละเอียด',
    history: 'ประวัติสต็อก',
    editCategory: 'แก้ไขข้อมูลหมวดหมู่สินค้า',
    editType: 'แก้ไขข้อมูลประเภทสินค้า',
    receipt: 'ใบเสร็จรับเงิน'
  },
  headers: {
    no: 'รหัสสินค้า',
    name: 'ชื่อสินค้า',
    category: 'หมวดหมู่',
    productCategory: 'หมวดหมู่สินค้า',
    type: 'ประเภท',
    status: 'สถานะ',
    sale: 'การขาย'
  },
  label: {
    nameTh: 'ชื่อสินค้า',
    nameEn: 'ชื่อสินค้า (EN)',
    nameCn: 'ชื่อสินค้า (CN)',
    category: 'หมวดหมู่',
    selectedProduct: 'เลือกสินค้า',
    productCategory: 'หมวดหมู่สินค้า',
    categoryName: 'ชื่อหมวดหมู่สินค้า',
    description: 'คำอธิบาย',
    mexDescription: '( ไม่เกิน 2,000 ตัวอักษร )',
    type: 'ประเภท',
    productType: 'ประเภทสินค้า',
    productTypeName: 'ชื่อประเภทสินค้า',
    unit: 'หน่วยสินค้า',
    unitName: 'ชื่อหน่วยสินค้า',
    remainingStock: 'สต็อกคงเหลือ',
    unitIn: 'หน่วยนำเข้า',
    subUnit: 'หน่วยย่อย',
    subUnitPer: 'ปริมาณหน่วยย่อย/หน่วยนำเข้า',
    minQty: 'ปริมาณต่ำสุด (หน่วยนำเข้า)',
    maxQty: 'ปริมาณสูงสุด (หน่วยนำเข้า)',
    detail: 'รายละเอียด',
    howToUse: 'วิธีใช้',
    timeUse: 'เวลาใช้',
    preserve: 'วิธีเก็บรักษา',
    properties: 'สรรพคุณ',
    guide: 'คำแนะนำ',
    sale: 'การขาย',
    pricePerUnit: 'ราคาซื้อต่อหน่วย',
    buyPrice: 'ราคาซื้อ',
    salePrice: 'ราคาขาย',
    productPrice: 'ราคาขายสินค้า',
    haveVAT: 'มี VAT',
    noVAT: 'ไม่มี VAT',
    typeVAT: 'ประเภท VAT',
    sumVAT: 'VAT คำนวณรวมกับราคาสินค้า',
    noSumVAT: 'VAT คำนวณแยกกับราคาสินค้า',
    startPrice: 'ราคาเริ่มต้น',
    priceBeforeVat: 'ราคาก่อน VAT',
    sumInProductPrice: 'คิดรวมในราคาสินค้า',
    noSumInProductPrice: 'คิดแยกในราคาสินค้า',
    commission: 'ค่าคอมมิชชั่น',
    haveCommission: 'มีค่าคอมมิชชั่น',
    noCommission: 'ไม่มีค่าคอมมิชชั่น',
    note1: 'หมายเหตุ: ค่าคอมมิชชั่น ที่กรอกจะนำไปหักจาก ราคาขายสินค้า',
    note2: 'และใช้สำหรับการนำไปแบ่งเป็น ค่าคอมมิชชั่น ให้กับ ผู้ขายสินค้า',
    bath: 'บาท',
    profit: 'กำไร',
    discount: 'ส่วนลด',
    treatmentFee: 'ค่าตรวจรักษา',
    maxDescription: '( 200-2,000 ตัวอักษร )',
    backToPOS: 'กลับหน้า แคชเชียร์',
    receiptId: 'หมายเลขใบเสร็จรับเงิน'
  },
  placeholder: {
    nameTh: 'กรอกชื่อสินค้า',
    nameEn: 'กรอกชื่อสินค้าภาษาอังกฤษ',
    nameCn: 'กรอกชื่อสินค้าภาษาจีน',
    category: 'เลือกหมวดหมู่',
    enterUnitInfo: 'กรอกข้อมูลหน่วยสินค้า',
    unitName: 'กรอกชื่อหน่วยสินค้า',
    unitIn: 'เลือกหน่วยนำเข้า',
    productType: 'กรอกข้อมูลประเภทสินค้า',
    productTypeName: 'กรอกชื่อประเภทสินค้า',
    subUnit: 'เลือกหน่วยย่อย',
    subUnitPer: 'ปริมาณหน่วยย่อย/หน่วยนำเข้า',
    minQty: 'กรอกปริมาณต่ำสุด',
    maxQty: 'กรอกปริมาณสูงสุด',
    detail: 'รายละเอียด',
    howToUse: 'กรอกวิธีใช้ (แสดงบนฉลากยา)',
    timeUse: 'กรอกเวลาใช้ (แสดงบนฉลากยา)',
    preserve: 'กรอกวิธีเก็บรักษา',
    properties: 'กรอกสรรพคุณ (แสดงบนฉลากยา)',
    guide: 'คำแนะนำ (แสดงบนฉลากยา)',
    sale: 'การขาย',
    pricePerUnit: 'กรอกราคาซื้อ',
    buyPrice: 'ราคาซื้อ',
    salePrice: 'กรอกราคา',
    productPrice: 'ราคาขายสินค้า',
    haveVAT: 'มี VAT',
    noVAT: 'ไม่มี VAT',
    typeVAT: 'ประเภท VAT',
    sumVAT: 'VAT คำนวณรวมกับราคาสินค้า',
    noSumVAT: 'VAT คำนวณแยกกับราคาสินค้า',
    startPrice: 'ราคาเริ่มต้น',
    priceBeforeVat: 'ราคาก่อน VAT',
    sumInProductPrice: 'คิดรวมในราคาสินค้า',
    noSumInProductPrice: 'คิดแยกในราคาสินค้า',
    commission: 'ค่าคอมมิชชั่น',
    haveCommission: 'มีค่าคอมมิชชั่น',
    noCommission: 'ไม่มีค่าคอมมิชชั่น',
    note1: 'หมายเหตุ: ค่าคอมมิชชั่น ที่กรอกจะนำไปหักจาก ราคาขายสินค้า',
    note2: 'และใช้สำหรับการนำไปแบ่งเป็น ค่าคอมมิชชั่น ให้กับ ผู้ขายสินค้า',
    bath: 'บาท',
    profit: 'กำไร',
    searchIdName: 'ค้นหารหัสสินค้า, ชื่อสินค้า',
    searchProductUnitName: 'ค้นหาชื่อหน่วยสินค้า',
    productCategory: 'กรอกหมวดหมู่สินค้า',
    info: 'กรอกข้อมูลหมวดหมู่สินค้า',
    productUnitUpdateSuccess: 'แก้ไขหน่วยสินค้าสำเร็จ !',
    confirmDeleteProductUnit: 'ยืนยันการลบหน่วยสินค้า',
    categoryName: 'กรอกชื่อหมวดหมู่สินค้า',
    description: 'กรอกคำอธิบายหมวดหมู่สินค้า',
    typeDescription: 'กรอกคำอธิบายประเภทสินค้า',
    searchProductCategory: 'ค้นหาชื่อหมวดหมู่สินค้า',
    searchProductType: 'ค้นหาชื่อประเภทสินค้า',
    treatmentFee: 'กรอกค่าตรวจรักษา'
  },
  statusProduct: {
    belowControl: 'ต่ำกว่าปริมาณควบคุม',
    withinControl: 'อยู่ในปริมาณควบคุม',
    aboveControl: 'เกินปริมาณควบคุม'
  },
  toolTip: {
    see: 'ดูข้อมูลสินค้า',
    create: 'สร้างสินค้าใหม่',
    edit: 'แก้ไขข้อมูล',
    duplicate: 'ทำซ้ำข้อมูล',
    delete: 'ลบข้อมูล'
  },
  modal: {
    deleteConfirm: 'ยืนยันการลบสินค้า',
    deleteDelete: 'คุณกำลังลบสินค้า ต้องการดำเนินการต่อหรือไม่ ?',
    create: {
      category: {
        success: 'เพิ่มหมวดหมู่สินค้าสำเร็จ !'
      },
      type: {
        success: 'เพิ่มประเภทสินค้าสำเร็จ !'
      },
      unit: {
        success: 'เพิ่มหน่วยสินค้าสำเร็จ !'
      }
    },
    edit: {
      category: {
        success: 'แก้ไขหมวดหมู่สินค้าสำเร็จ !'
      },
      type: {
        success: 'แก้ไขประเภทสินค้าสำเร็จ !'
      }
    },
    delete: {
      category: {
        title: 'ยืนยันการลบหมวดหมู่สินค้า',
        subTitle: 'คุณกำลังลบหมวดหมู่สินค้า ต้องการดำเนินการต่อหรือไม่',
        success: 'ลบหมวดหมู่สินค้าสำเร็จ !'
      },
      type: {
        title: 'ยืนยันการลบประเภทสินค้า',
        subTitle: 'คุณกำลังลบประเภทสินค้า ต้องการดำเนินการต่อหรือไม่ ?',
        success: 'ลบประเภทสินค้าสำเร็จ !'
      }
    }
  },
  alert: {
    deleted: 'ลบสินค้าสำเร็จ'
  }
}
